import "./haloViolet.css";

export default function VioletHaloBackground({
  count = 3,
  size = 1500,
  opacity = 0.6,
  durationMin = 8,
  durationMax = 10,
  marginPct = 1,
}) {
  const clampPct = (p) => Math.max(0, Math.min(40, p));
  const m = clampPct(marginPct);

  const rndInRange = (min, max) => (Math.random() * (max - min) + min).toFixed(2);

  const makeOrbStyle = () => {
    const dur =
      Math.floor(durationMin + Math.random() * (durationMax - durationMin));
    const delay = Math.floor(Math.random() * 8) * -1; 


    const x1 = `${rndInRange(m, -40- m)}vw`;
    const y1 = `${rndInRange(m, -60- m)}vh`;
    const x2 = `${rndInRange(m, 50- m)}vw`;
    const y2 = `${rndInRange(m, 25- m)}vh`;

    return {
      "--orb-size": `${size}px`,
      "--orb-opacity": opacity,
      "--x1": x1,
      "--y1": y1,
      "--x2": x2,
      "--y2": y2,
      animationDuration: `${dur}s`,
      animationDelay: `${delay}s`,
    };
  };

  return (
    <div className="violet-halo-layer" aria-hidden>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="violet-halo" style={makeOrbStyle()} />
      ))}
    </div>
  );
}

